import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import {
  RenderEnvironmentContext,
  ReploElementContext,
  ShopifyStoreContext,
  useRuntimeContext,
} from "../../../shared/runtime-context";
import { isFeatureSupported } from "../../../shared/utils/supportedFeatures";
import { wrapProductAssignmentToLiquidSource } from "../../utils/reviews";
import RenderComponentPlaceholder from "../RenderComponentPlaceholder";
import { SharedShopifyLiquid } from "../SharedShopifyLiquid";

const ShopifyRawLiquid: React.FC<RenderComponentProps> = ({
  component,
  context,
  componentAttributes,
}) => {
  const { storeUrl } = useRuntimeContext(ShopifyStoreContext);
  const isShopifyStoreConnected = Boolean(storeUrl);
  const { elementType } = useRuntimeContext(ReploElementContext);
  const { state } = context;
  const liquidContent = component.props._liquidContent ?? "";
  const product = state.product?.product ?? null;
  const liquidSourceWithProductAssignment = wrapProductAssignmentToLiquidSource(
    {
      product,
      liquidSource: liquidContent,
      context,
    },
  );
  const { isEditorApp } = useRuntimeContext(RenderEnvironmentContext);

  if (isEditorApp) {
    return (
      <div {...componentAttributes}>
        <RenderComponentPlaceholder type="html" title="Custom Liquid" />
      </div>
    );
  }

  if (!isShopifyStoreConnected) {
    return (
      <div {...componentAttributes}>
        <RenderComponentPlaceholder
          type="html"
          title="Custom Liquid"
          descriptionOverride="Connect Shopify to publish and view your Liquid content."
        />
      </div>
    );
  }

  return (
    <SharedShopifyLiquid
      liquidSource={liquidSourceWithProductAssignment}
      componentId={component.id}
      componentAttributes={componentAttributes}
      isLiquidSupported={isFeatureSupported(elementType, "shopifyLiquid")}
    />
  );
};

export default ShopifyRawLiquid;
